import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";
import { axiosApi } from "./axios";
import { LogPermissionDto } from "@/types/api/api-types";
import { UpdateLogPermissionsDto } from "@/types/api/api-types";

const QUERY_KEY = ["log-permissions"];

const getLogPermissions = () =>
  axiosApi.get<LogPermissionDto[]>("/log/permissions").then((r) => r.data);

const setAllLogPermissions = (payload: UpdateLogPermissionsDto) =>
  axiosApi.put("/log/permissions", payload).then((r) => r.data);

export const useGetLogPermissions = () =>
  useQuery({ queryKey: QUERY_KEY, queryFn: getLogPermissions });

export const useSetAllLogPermissions = () => {
  const queryClient = useQueryClient();
  const { t } = useTranslation("boParameters");
  return useMutation({
    mutationFn: setAllLogPermissions,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: QUERY_KEY });
    },
    onError: () => {
      toast.error(t("logPermissionsApi.saveError"));
    },
  });
};
